export default __webpack_public_path__ + "static/media/Group5600.b3df2522.png";